import { AppointmentsRoutes } from '../../../state/constants';
import { client } from 'graphql/client';
import { goTo } from 'router/navigation';
import { useEffect } from 'react';

import {
  useFetchCounsellorByIdLazyQuery,
  useFetchCounsellorForChatLazyQuery,
} from 'graphql-types';
import { getCounsellorName } from 'pages/appointments/state/helpers';

export const useCounsellorProfile = (counsellorId: string | null) => {
  const [fetchCounsellorProfile, { data, loading, error }] =
    useFetchCounsellorByIdLazyQuery();

  useEffect(() => {
    if (!counsellorId) {
      goTo(AppointmentsRoutes.COUNSELLOR_SELECTION);
      return;
    }

    fetchCounsellorProfile({ variables: { counsellorId } });
  }, []);

  return { data, loading, error };
};

export const useCounsellorForChat = () => {
  const [fetchCounsellorForChat] = useFetchCounsellorForChatLazyQuery({
    client,
  });

  const fetchCounsellorName = async (
    counsellorId: string,
  ): Promise<string | null> => {
    const fetchedData = await fetchCounsellorForChat({
      variables: { counsellorId },
      fetchPolicy: 'cache-first',
    });

    if (fetchedData.data?.fetchCounsellorById?.counsellor) {
      const { firstName, lastName } =
        fetchedData.data.fetchCounsellorById.counsellor;

      const name = getCounsellorName({
        firstName,
        lastName,
      });

      return name;
    }

    return Promise.reject(
      new Error('Failed to fetchCounsellorName', fetchedData?.error),
    );
  };

  return { fetchCounsellorName };
};
